import { useState, useEffect } from "react";
import "./CookiesBanner.css"; // Import the CSS file

const CookiesBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasAgreed = localStorage.getItem("cookieConsent");
    if (!hasAgreed) {
      setIsVisible(true);
    }
  }, []);

  const handleAgree = () => {
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner">
      <p>
        By using the website, you agree to our use of cookies to analyze website
        traffic and improve your experience.
        <a href="/privacy-policy" className="learn-more">
          Learn more
        </a>
      </p>
      <div className="buttons">
        <button className="agree-btn" onClick={handleAgree}>
          I Agree
        </button>
        <button className="close-btn" onClick={handleClose}>
          ✕
        </button>
      </div>
    </div>
  );
};

export default CookiesBanner;
